import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { dns } from 'src/app/global.config';
import { TypePoiRequestDto, TypePoiResponseDto } from './type-poi.model';
import { createAuthorizationHeader } from 'src/app/utils/security/headers';
@Injectable({
  providedIn: 'root'
})
export class TypePoiRestService {

   private url = dns + 'type-poi'

  constructor(private _http:HttpClient) {}

    getAllTypePoi(): Observable<TypePoiResponseDto[]> {
      let headers = createAuthorizationHeader();
        return this._http.get<TypePoiResponseDto[]>(`${this.url}`,{ headers: headers });
    }

    getAllTypePoiLight(): Observable<TypePoiResponseDto[]> {
      let headers = createAuthorizationHeader();
        return this._http.get<TypePoiResponseDto[]>(`${this.url}/light`,{ headers: headers });
    }

    addTypePoi(typePoi: TypePoiRequestDto): Observable<TypePoiResponseDto> {
      let headers = createAuthorizationHeader();
        return this._http.post<TypePoiResponseDto>(`${this.url}`, typePoi,{ headers: headers });
    }

    updateTypePoi(typePoi: TypePoiRequestDto): Observable<TypePoiResponseDto> {
      let headers = createAuthorizationHeader();
        return this._http.put<TypePoiResponseDto>(`${this.url}`, typePoi,{ headers: headers });
    }

    deleteTypePoi(idTypePoi:number){
      let headers = createAuthorizationHeader();
        return this._http.delete(`${this.url}/${idTypePoi}`,{ headers: headers });
    }
}
